<div
  class="nav-tooltip-invest"
  [style.--tooltip-arrow-left-invest]="tooltipArrowPosition"
>
  <ng-container *ngIf="isLoading">
    <div class="text-center col-12 w-100" style="padding: 20px 0 30px 0">
      <app-spinner></app-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">
    <div class="nav-tooltip-invest__left">
      <div>
        <img src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/invest/arrow-invest-icon.svg" alt="" />
      </div>
      <div>
        <h2 class="mb-2">{{ 'components.navTooltipInvest.title' | translate }}</h2>
        <p class="text-thin mb-2">
          {{ 'components.navTooltipInvest.description' | translate }}
        </p>
        <p class="text-thin">{{ 'components.navTooltipInvest.detalle' | translate }}</p>
      </div>
    </div>
    <div class="nav-tooltip-invest__cards">
      <ngb-carousel
        [showNavigationArrows]="false"
        [showNavigationIndicators]="false"
        [interval]="3000"
        class="nav-tooltip-invest-ngb"
      >
        <!-- Si hay exactamente 3 ítems, mostrar solo una slide con los 3 ítems -->
        <ng-template ngbSlide *ngIf="visibleCards.length <= 3">
          <div class="card-carousel-group">
            <ng-container *ngFor="let card of visibleCards">
              <div
                class="card-carousel"
                *ngIf="card.image_view"
                (click)="goNavigateToUrl(card)"
              >
                <img
                  [src]="card.image_path"
                  [alt]="card.title"
                  class="card-carousel__img"
                />
                <div class="card-carousel__content">
                  <span *ngIf="card.badge" class="card-carousel__badge">
                    {{ card.badge }}
                  </span>
                  <span class="card-carousel__title">
                    {{ language === 'en' ? card.title_en : card.title }}
                  </span>
                  <span class="card-carousel__cta">
                    <img
                      src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/invest/arrow-round-icon.svg"
                      alt=""
                    />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-template>

        <!-- Si hay más de 3 ítems, mostrar slides iterando y haciendo loop -->
        <ng-container *ngIf="visibleCards.length > 3">
          <ng-template
            ngbSlide
            *ngFor="
              let i of [].constructor(visibleCards.length);
              let idx = index
            "
          >
            <div class="card-carousel-group">
              <ng-container *ngFor="let j of [0, 1, 2]">
                <div
                  class="card-carousel"
                  *ngIf="
                    visibleCards[(idx + j) % visibleCards.length]?.image_view
                  "
                  (click)="
                    goNavigateToUrl(
                      visibleCards[(idx + j) % visibleCards.length]
                    )
                  "
                >
                  <img
                    [src]="
                      visibleCards[(idx + j) % visibleCards.length]?.image_path
                    "
                    [alt]="visibleCards[(idx + j) % visibleCards.length]?.title"
                    class="card-carousel__img"
                  />
                  <div class="card-carousel__content">
                    <span
                      *ngIf="
                        visibleCards[(idx + j) % visibleCards.length]?.badge
                      "
                      class="card-carousel__badge"
                      >{{
                        visibleCards[(idx + j) % visibleCards.length]?.badge
                      }}</span
                    >
                    <span class="card-carousel__title">{{
                      visibleCards[(idx + j) % visibleCards.length]?.title
                    }}</span>
                    <span class="card-carousel__cta">
                      <img
                        src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/invest/arrow-round-icon.svg"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ng-container>
      </ngb-carousel>
      <div
        class="card-carousel card-carousel--all"
        (click)="goNavigateToUrlAll()"
      >
        <div class="card-carousel__icon-wrapper">
          <div class="card-carousel__icon">
            <img
              src="https://inviertis-prd.s3.eu-central-1.amazonaws.com/assets/icons/invest/windows-invest-icon.svg"
              alt="Ver todo"
            />
          </div>
        </div>
        <span class="card-carousel__all-text desktop">
          <span>{{ 'components.navTooltipInvest.ver' | translate }}</span><br />
          <span>{{ 'components.navTooltipInvest.todo' | translate }}</span>
        </span>
        <span class="card-carousel__all-text mobile">
          <span>{{ 'components.navTooltipInvest.ver' | translate }}</span>
          <span class="ms-2">{{ 'components.navTooltipInvest.todo' | translate }}</span>
        </span>
      </div>
    </div>
  </ng-container>
</div>
